import {
  commitMutation,
  graphql
} from 'react-relay';

import environment from '../Environment';

const mutation = graphql`
mutation UpdateUsersToIgnoreMutation($emails: String!) {
  updateUsersToIgnore(emails: $emails) { 
    ok
    error
  }
}
`;

export default (
  emails,
  done) => {

  const variables = {
    emails
  };

  commitMutation(
    environment,
    {
      mutation,
      variables,
      onCompleted: (response) => {
        const { ok, error } = response.updateUsersToIgnore;
        done(ok, error);
      },
      onError: err => console.error(err)
    }
  );
};
